<script>
  import QuestionFrame from './QuestionFrame.svelte';
</script>

<QuestionFrame>
  <p>Haben Sie ein Fremdkörpergefühl?</p>
  <p>
    Zum Beispiel das Gefühl von einem Tennisball hinter dem Damm oder einem Golfball im Enddarm.
  </p>
</QuestionFrame>
